<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        车辆基础信息
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="表格列设置"
            icon="e6-icon-field_line"
            @click="columSetVisible = !columSetVisible"
            plain
          ></el-button>
          <el-button
            v-if="operationSuper.编辑"
            class="g-form-section-search operate__item"
            title="编辑"
            icon="el-icon-plus"
            @click="$router.push('/baseVehicleEdit')"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="导入"
            v-if="operationSuper.导入"
            icon="e6-icon-Import_fill"
            @click="openImport"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.comparyName">
            <el-input
              v-model="slotForms.forms.comparyName"
              placeholder="企业名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="forms.vehicleTypeId">
            <dict-select
              v-model="slotForms.forms.vehicleTypeId"
              placeholder="车辆类型"
              :pkey="'vehicle_type'"
            ></dict-select>
          </el-form-item>
          <el-form-item>
            <!-- <e6-select
              :dataList="vehicleList"
              :filterable="true"
              slotTemplate="tree"
              :issingleleaf="true"
              multiple
              ref="vehicleTreeSelect"
              :placeholder="'车辆'"
            ></e6-select> -->
            <e6-vr-select
              :data="vehicleList"
              ref="select"
              v-model="vehicleData"
              @change="change"
              :search="true"
              placeholder="车辆"
              multiple
              isStrict
              allow-create
            >
            </e6-vr-select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="tableLoading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          label="序号"
          width="80"
          fixed
          type="index"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in localShowTableCols"
          :key="index"
          :show-overflow-tooltip="true"
          min-width="150"
          align="center"
          :prop="item.name"
          :label="item.title"
        >
          <template slot-scope="{ row }">
            <div
              v-if="
                item.name == 'temperatureStr' &&
                  row[item.name] == '-99.00℃--99.00℃'
              "
            ></div>
            <div v-else>
              {{ row[item.name] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.coldVehicleId && scope.row.coldVehicleId > 0"
              @click="initQRCode(scope.row.vehicleNum, scope.row.vehicleId)"
              type="text"
              size="small"
            >
              下载二维码
            </el-button>
            <router-link
              v-if="operationSuper.编辑"
              :to="{
                path: '/baseVehicleEdit',
                query: {
                  pageType: '2',
                  id: scope.row.vehicleId,
                  provinceId: scope.row.provinceId
                }
              }"
              >编辑</router-link
            >&nbsp;
            <el-button
              v-if="operationSuper.删除"
              @click="deleteRow(scope)"
              type="text"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 表格列设置 -->
    <e6-column-set
      @setColumnSubmit="handleSetColumnSubmit"
      @setColumnCancel="handleSetColumnCancel"
      :columSetVisible.sync="columSetVisible"
      :hideTableCols.sync="copyHideTableCols"
      :showTableCols.sync="copyShowTableCols"
    ></e6-column-set>
    <!-- 表格列设置 end -->
    <!-- 查看线路二维码弹框 -->
    <section>
      <el-dialog
        ref="myCode"
        title="二维码"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="myCodeVisible"
        width="330px"
        @close="handleCloseMyCode"
      >
        <div class="vehicle_qrCode">
          <div class="vehicle_info">车辆"{{ curVehicleNo }}"二维码下载</div>
          <div id="qrCode" ref="qrCodeDiv"></div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleCloseMyCode()">取消</el-button>
          <el-button type="primary" @click="downs()">下载</el-button>
        </div>
      </el-dialog>
    </section>
    <!--导入弹框-->
    <upload-center
      ref="addGoodsFile"
      :visible.sync="dialogImportVisible"
      :initInfo="importParams"
    ></upload-center>
  </div>
</template>

<script>
import { DeleteDataById, getVehicleInfoTreeForNew } from "@/api/base/vehicle";
import { mapActions } from "vuex";
import { mergeFormExtend } from "_private/utils/merge";
import operationManage from "_private/mixins/operationManage";
import listInit from "@/mixins/listInit";
import QRCode from "qrcodejs2"; // 生成二维码
import uploadCenter from "@/components/uploadCenter";
export default {
  components: { uploadCenter },
  mixins: [operationManage, listInit],
  data() {
    return {
      transportsList: [
        { label: "进口冷链食品", id: 1 },
        { label: "冷链城市配送", id: 2 },
        { label: "医用疫苗，其他（字典表维护）", id: 3 }
      ],
      isSearch: false,
      vehicleList: [],
      formExtend: {
        forms: {
          comparyName: "",
          vehicleTypeId: ""
        },
        extends: []
      },
      vehicleIds: [],
      vehicleData: [],
      columSetVisible: false,
      multipleSelection: [],
      messageBoxVisible: false,
      analysisError: false,
      aErrorDatas: [],
      idList: [],
      errMess: "",
      isFirstLoad: true,
      // 请求表格数据
      tableDataUrl: "/base/vehicle/findByPage",
      //导出URL
      exportUrl: "/base/vehicle/exportVehicleInfo?",
      // 我的关联码弹框
      myCodeVisible: false,
      curVehicleNo: "",
      myCode: {
        code: ""
      },
      // 导入相关
      dialogImportVisible: false,
      importParams: {
        title: "导入车辆信息",
        templateUrl: "/static/车辆导入模板.xlsx",
        importUrl: "/base/vehicle/import"
      }
    };
  },

  created() {
    //初始化区位树
    this.getVehicleData();
    this.setSearchFormIsOpenAct();
    this.initPage();
  },
  mounted() {
    let idStr = this.$route.query.vehicleIds;
    if (idStr) {
      this.idList = idStr.split(",");
    }
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    vehicleFilter(val) {
      setTimeout(() => {
        this.getVehicleData(val || "");
      });
    },
    change() {
      this.vehicleData = this.$refs.select.getChecked().id;
      console.log(this.vehicleData);
    },
    async getVehicleData(vehicleNum) {
      const res = await getVehicleInfoTreeForNew({
        vehicleNum
      });
      this.vehicleList = res.result;
    },
    // 删除行
    deleteRow({ row }) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.tableLoading = true;

          const { code, message } = await DeleteDataById({
            ids: row.vehicleId
          });

          this.tableLoading = false;

          if (code === 1) {
            this.successMessage("删除成功", () => {
              this.handleCurrentChange(1);
            });
          } else {
            this.errorMessage(message || "删除失败，请重试");
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //--------------------二维码-----------------------
    // 初始化二维码
    initQRCode(vehicleNum, vehicleId) {
      this.myCodeVisible = true;
      this.curVehicleNo = vehicleNum;
      let params = encodeURI(vehicleId)
        .replace("(", "%28")
        .replace(")", "%29");
      let baseUrl = window.location.origin;
      this.$nextTick(() => {
        new QRCode(this.$refs.qrCodeDiv, {
          text: `${baseUrl}/static/vehicleDetail.html?vehicleNum=${params}`,
          width: 150,
          height: 150,
          colorDark: "#333333" //二维码颜色
        });
      });
    },
    handleCloseMyCode() {
      this.myCodeVisible = false;
      this.$nextTick(() => {
        this.curLine = {};
        this.$refs.qrCodeDiv.innerHTML = "";
      });
    },
    // 下载二维码图片
    downs() {
      //找到canvas标签
      let myCanvas = document
        .getElementById("qrCode")
        .getElementsByTagName("canvas");
      let img = document.getElementById("qrCode").getElementsByTagName("img");
      //创建一个a标签节点
      let a = document.createElement("a");
      //设置a标签的href属性（将canvas变成png图片）
      let imgURL = myCanvas[0].toDataURL("image/jpg");
      let ua = navigator.userAgent;
      if (ua.indexOf("Trident") != -1 && ua.indexOf("Windows") != -1) {
        // IE内核 并且  windows系统 情况下 才执行;
        var bstr = atob(imgURL.split(",")[1]);
        var n = bstr.length;
        var u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        var blob = new Blob([u8arr]);
        window.navigator.msSaveOrOpenBlob(blob, "下载" + "." + "png");
      } else if (ua.indexOf("Firefox") > -1) {
        //火狐兼容下载
        let blob = this.base64ToBlob(imgURL); //new Blob([content]);
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent("click", true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
        a.download = `${this.curLine.lineName}(${this.curLine.lineCode})`; //下载图片名称，如果填内容识别不到，下载为未知文件，所以我这里就不填为空
        a.href = URL.createObjectURL(blob);
        a.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window
          })
        );
      } else {
        //谷歌兼容下载
        img.src = myCanvas[0].toDataURL("image/jpg");
        a.href = img.src;
        //设置下载文件的名字
        a.download = `${this.curVehicleNo}`;
        //点击
        a.click();
      }
    },
    //base64转blob
    base64ToBlob(code) {
      let parts = code.split(";base64,");
      let contentType = parts[0].split(":")[1];
      let raw = window.atob(parts[1]);
      let rawLength = raw.length;
      let uInt8Array = new Uint8Array(rawLength);
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], { type: contentType });
    },
    // 整合查询数据
    mergeObj() {
      let vehicleIdList;
      if (this.isFirstLoad) {
        vehicleIdList = this.idList;
        this.isFirstLoad = false;
      } else {
        vehicleIdList = this.vehicleData;
      }
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        vehicleIdList: vehicleIdList,
        curPage: this.curPage,
        pageSize: this.pageSize
      });
    },
    //重置
    handleResetForm() {
      this.vehicleData = [];
    },
    handleExportClick() {
      let vehicleIdList;
      if (this.isFirstLoad) {
        vehicleIdList = this.idList;
        this.isFirstLoad = false;
      } else {
        vehicleIdList = this.vehicleData;
      }
      let param = "";
      param += "&comparyName=" + this.formExtend.forms.comparyName;
      param += "&vehicleTypeId=" + this.formExtend.forms.vehicleTypeId;
      param += "&vehicleIdList=" + vehicleIdList;
      document.location.href = this.exportUrl + param;
    },
    /*------------------------------导入-----------------------------------*/
    openImport() {
      this.dialogImportVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}
/deep/ .el-table__body-wrapper {
  height: calc(100% - 36px) !important;
}

/deep/ .e6-from--column-2 .vehicle_temp {
  width: 100px !important;
}

/deep/ .el-dialog {
  .el-dialog__body {
    padding: 10px 20px;
    .vehicle_qrCode {
      text-align: center;
      .vehicle_info {
        margin: 10px;
        font-size: 16px;
      }
      #qrCode {
        display: flex;
        justify-content: center;
      }
    }
  }
}
// /deep/ .el-table__body-wrapper {
//   height: calc(100% - 36px) !important;
// }
// /deep/ .el-table__fixed-body-wrapper {
//   height: calc(100% - 36px) !important;
//   top: 36px !important;
// }
/deep/.select-box {
  width: 220px !important;
}
</style>
